export const defaultConfigColunas = [
  { nome: "id", exibir: true },
  { nome: "placa", exibir: true },
  { nome: "renavam", exibir: true },
  { nome: "chassi", exibir: true },
  { nome: "dataCadastroProcesso", exibir: true },
  { nome: "escolhaPlaca", exibir: true },
  { nome: "numeroProcesso", exibir: true },
  { nome: "dataHoraProcesso", exibir: true },
  { nome: "despachante", exibir: true },
  { nome: "agenteFinanceiro", exibir: true },
  { nome: "codigoBarras", exibir: true },
  { nome: "valorDataVencimento", exibir: true },
  { nome: "escPla", exibir: true },
  { nome: "gp", exibir: true },
  { nome: "taxa", exibir: true },
  { nome: "gpd", exibir: true },
  { nome: "ap", exibir: true },
  { nome: "lic", exibir: true },
  { nome: "pla", exibir: true },
  { nome: "ipva", exibir: true },
  { nome: "blo", exibir: true },
  { nome: "fin", exibir: true },
  { nome: "info", exibir: true },
];
